import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authSlice } from './slices/authSlice';
import { merchantSlice } from './slices/merchantSlice';
import { installUserMerchantPreferencesResolver } from './userMerchantPreferencesResolver';

// Redux store: the session slices and the modules wired to them
//
//    ┌──────────── store.ts ────────────┐
//    │  auth:     authSlice             │
//    │  merchant: merchantSlice         │
//    └─────────────────┬────────────────┘
//                      │
//                      ├── sessionLifecycle actions         both slices react to them
//                      ├── selectSessionStatus              reads both → one session status
//                      ├── userMerchantPreferencesResolver  reads both outside React
//                      └── hooks.ts                         typed useAppSelector / useAppDispatch for components

export const rootReducer = combineReducers({
  auth: authSlice.reducer,
  merchant: merchantSlice.reducer
});

export const store = configureStore({
  reducer: rootReducer
});

// At import rather than from a provider: consumers read preferences in a useState initializer,
// which can run before any ancestor has rendered or run an effect.
installUserMerchantPreferencesResolver(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
